exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login {\n  position: relative;\n  max-width: 460px;\n  width: 100%;\n  margin: auto;\n  left: 0;\n  right: 0;\n  transform: translateY(50%);\n  text-align: center;\n  box-sizing: border-box;\n  padding: 10px 20px;\n  z-index: 1; }\n  @media screen and (orientation: landscape) and (max-height: 460px) {\n    .login {\n      position: relative;\n      margin: 50px auto;\n      transform: none; } }\n\nimg.logo {\n  position: relative;\n  width: 100%;\n  z-index: 2;\n  display: block;\n  padding-top: 3vh;\n  margin: 0 auto 20px;\n  max-width: 500px; }\n\nbutton {\n  margin-top: 20px;\n  max-width: 320px; }\n\n.login form {\n  width: 100%;\n  margin: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/components/login/login.component.scss
// module id = ../../../../../src/app/components/login/login.component.scss
// module chunks = main